module.exports = __webpack_public_path__ + "img/ico_copy_grey.3a66ea07.svg";